import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RoutingService, TranslatePipe, UrlPipe } from '@spartacus/core';
import { AmendOrderActionsComponent } from '@spartacus/order/components';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-efa-amend-order-actions',
    templateUrl: './efa-amend-order-actions.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, TranslatePipe, UrlPipe]
})
export class EfaAmendOrderActionsComponent extends AmendOrderActionsComponent {

  constructor(protected routingService: RoutingService) { 
    super(routingService);
  }
}
